"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yourContactInformationHeading = exports.socialAccountsHeadingText = exports.skillsHeadingText = exports.resumeHeadingText = exports.projectsHeadingText = exports.otherPreferencesHeadingText = exports.languagesHeadingText = exports.friendsHeadingText = exports.educationHeadingText = exports.contactInfoHeadingText = exports.contactInfoEmptyHeadingText = exports.communitiesHeadingText = exports.bioHeadingText = void 0;
const yourContactInformationHeading = exports.yourContactInformationHeading = 'Your profile';
const otherPreferencesHeadingText = exports.otherPreferencesHeadingText = 'Other preferences';
const communitiesHeadingText = exports.communitiesHeadingText = 'Your communities';
const resumeHeadingText = exports.resumeHeadingText = 'Resume';
const bioHeadingText = exports.bioHeadingText = 'Bio';
const educationHeadingText = exports.educationHeadingText = 'Education';
const skillsHeadingText = exports.skillsHeadingText = 'Skills';
const languagesHeadingText = exports.languagesHeadingText = 'Languages';
const projectsHeadingText = exports.projectsHeadingText = 'Projects & Communities';
const contactInfoHeadingText = exports.contactInfoHeadingText = 'More Contacts';
const contactInfoEmptyHeadingText = exports.contactInfoEmptyHeadingText = 'Contact Info';
const socialAccountsHeadingText = exports.socialAccountsHeadingText = 'Follow me on';
const friendsHeadingText = exports.friendsHeadingText = 'Friends';